import { render, staticRenderFns } from "./OmniView.vue?vue&type=template&id=dd78f200&scoped=true&"
import script from "./OmniView.vue?vue&type=script&setup=true&lang=js&"
export * from "./OmniView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OmniView.vue?vue&type=style&index=0&id=dd78f200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd78f200",
  null
  
)

export default component.exports